import api, { buildURLWithParams } from '@/services/api';

import type { ProductInsertImageAssetDTO } from '../types';

const IMAGE_ASSETS_URL = '/product-image-assets';

export async function getProductImageAssets(productId: number, draftId?: number) {
  // Either one, never both: a draft id reads the draft's staged gallery, a product id the published one.
  const params = draftId ? { draftId } : { productId };
  return await api.get<ProductInsertImageAssetDTO[]>(buildURLWithParams(IMAGE_ASSETS_URL, params));
}
